import { CARD_SWATCHES } from './cards'

import type { FC } from 'react'

export interface CardDivsProps {
  cards: Record<string, number> | undefined
  cardColors: string[]
  baseHeight: string
  widthMultiplier: number
  heightMultiplier: number
  className?: string
  ariaPrefix?: string
}

/**
 * Render N coloured rectangles per disciplinary color. A color with count 0
 * renders nothing. Returns null when no card has count > 0 so callers can
 * collapse the slot entirely.
 */
const CardDivs: FC<CardDivsProps> = ({
  cards,
  cardColors,
  baseHeight,
  widthMultiplier,
  heightMultiplier,
  className,
  ariaPrefix,
}) => {
  const groups = cardColors.map((color) => ({ color, count: cards?.[color] ?? 0 })).filter(({ count }) => count > 0)

  if (groups.length === 0) return null

  const width = `calc(${baseHeight} * ${widthMultiplier})`
  const height = `calc(${baseHeight} * ${heightMultiplier})`

  return (
    <div className={className}>
      {groups.map(({ color, count }) => (
        <div key={color} className="goal-sport-card-group" aria-label={`${ariaPrefix ?? ''}${color} cards: ${count}`}>
          {Array.from({ length: count }).map((_, i) => (
            <span key={i} className="goal-sport-card-div" style={{ width, height, background: CARD_SWATCHES[color] }} />
          ))}
        </div>
      ))}
    </div>
  )
}

export default CardDivs
